import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer, toast } from 'react-toastify';
import { ListsModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import AddNewGroup from '../../components/Modals/AddNewGroup';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import DeleteIcon from '@mui/icons-material/Delete';
import { launchPhoneBurner } from '../../common/utils';
import { singleSelectQuickFilter } from '../../common/utils';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';
import { removeLists } from '../../common/api';


const toolbar = ( { selectedRows, handleModal, hasTxting, hasPhoneBurner, canExport, viewing } ) => {
    return (
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                {/* <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) } disabled={viewing.length !== 1}>Send Mass Email</Dropdown.Item> */}
                                                {
                                                    hasTxting ? (
                                                        null
                                                        // <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) } disabled={viewing.length !== 1}>Send Mass Txt</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                {/* <Dropdown.Divider /> */}
                                                {
                                                    hasPhoneBurner ? (
                                                        <>
                                                            <Dropdown.Item onClick={ () => handleModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                            <Dropdown.Divider />
                                                        </>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Item onClick={ () => handleModal( 'event' ) } disabled={viewing.length !== 1}>Add to an Event</Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item onClick={ () => handleModal( 'delete' ) }>Delete Lists</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}


const Lists = ( { aid, uid, user, grids, viewing, canExport, stack, lists, contacts } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ lLists, setLists ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );

    const actions = [
        { icon: <EmailIcon />, label: 'Send Email', type: 'email' },
        { icon: <TextsmsIcon />, label: 'Send Txt', type: 'txt' },
        { icon: <DeleteIcon />, label: 'Delete', type: 'delete', dropdown: true },
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const gridHelpers = {
        valueGetter: {
            list: ( { row } ) => {
                // const l = lists[row.gid];
                return ( row && row.gid ) ? row.label : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            }
        },
        renderCell: {
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            list: ( { row } ) => {
                // const l = ( row && row.gid ) ? lists[row.gid] : null;
                return ( row && row.gid ) ? <Link to={`/list/${row.gid}`}>{row.label}</Link> : null;
            }
        },
        valueFormatter: {
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            list: ( { id } ) => {
                const l = lists[id];
                return ( l ) ? <Link to={`/list/${id}`}>{l.label}</Link> : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'new-group':
                setModal( <AddNewGroup close={closeModal} aid={viewing[0]} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = async ( t ) => {
        let shouldOpen = true;
        
        const cids = new Set();
        let cons = [];
        let groups = [];
        selectedRows.forEach( gid => {
            const l = lists[gid];
            groups.push( { aid: l.aid, gid: gid } );
            
            if ( l && l.cids && l.cids.length ) {
                l.cids.forEach( cid => {
                    cids.add( cid );
                    const c = contacts[cid];
                    if ( c ) {
                        cons.push( c );
                    }
                } );
            }
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={Array.from( cids )} objType='contact' /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={Array.from( cids )} objType='contact' /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            case 'phoneburner':
                await launchPhoneBurner( aid, uid, Array.from( cids ), cons, stack.dialer );
                shouldOpen = false;
                break;

            case 'delete':
                await removeLists( aid, uid, groups );
                shouldOpen = false;
                break;
                
            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    useEffect( () => {
        document.title = 'Third Floor - Lists';
    }, [] );

    useEffect( () => {
        if ( grids && grids.lists && grids.lists.cols && !gridReady ) {
            const storedCols = JSON.parse( grids.lists.cols );
            const cols = storedCols.map( c => {
                if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                    c.renderCell = gridHelpers.renderCell[c.renderCell];
                }
                if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                    c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                }
                if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                    c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                }
                if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                    c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                }
                return c;
            } );
            setCols( cols );
            setGridReady( true );
        }
    }, [ grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        let list = [];
        Object.keys( lists ).forEach( gid => {
            const l = lists[gid];

            if ( viewing.includes( l.aid ) ) {
                list.push( l );
            }
        } );
        list.sort( ( a, b ) => a.label.localeCompare( b.label ) );
        setLists( list );
        setLoading( false );
    }, [ lists, viewing ] );
    
    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Lists</span>
                                    </Col>
                                    <Col className='text-end'>
                                        <Button className='tf-obj-button' size='sm' onClick={ () => handleModal( 'new-group' ) } disabled={viewing.length > 1}>+ Add</Button>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            loading={ loading }
                                            rows={lLists}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { 
                                                toolbar: toolbar
                                            } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleModal: handleMassModal, 
                                                hasTxting: hasTxting, 
                                                hasPhoneBurner: hasPhoneBurner, 
                                                canExport: canExport,
                                                viewing: viewing
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            getRowId={ ( row ) => row.gid }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    lists: state.lists.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Lists );